import { render } from "./ProductGridV2.vue?vue&type=template&id=2ee7ab6c&scoped=true"
import script from "./ProductGridV2.vue?vue&type=script&lang=js"
export * from "./ProductGridV2.vue?vue&type=script&lang=js"

import "./ProductGridV2.vue?vue&type=style&index=0&id=2ee7ab6c&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee7ab6c"]])

export default __exports__